import React                from "react";
import PropTypes            from "prop-types";
import Flux                 from "../../flux/Flux";
import VideoTile            from "../Grid2/Tiles/VideoTile";
import Grid2                from "../Grid2/Grid2";
import ActorTooFewItemsTile from "../Grid2/Tiles/ActorTooFewItemsTile";

class SearchResultsVideosGrid extends React.PureComponent {
	constructor(props) {
		super(props);
	}

	render() {
		if (!Array.isArray(this.props.videos)) {
			return null;
		}
		const tileData        = this.props.videos.map(video => video.video);
		const tileClasses     = [];
		const tileSizes       = [];
		const tileConfigs     = [];
		const videosCount     = tileData.length;
		const isGuestLoggedIn = Flux.Guest.isLoggedIn();

		if (videosCount < 4) {
			tileClasses.push({index: videosCount, tileClass: ActorTooFewItemsTile});
			tileSizes.push({index: videosCount, size: {xs: videosCount === 0 ? 2 : (videosCount === 1 ? 1 : 4 - videosCount), lg: 4 - videosCount}});
			tileConfigs.push({index: videosCount, config: {}});
		}		

		return (
			<div className={"h-width-full"}>
				<Grid2 tileData={tileData}
				       defaultTileClass={VideoTile}
				       tileClasses={tileClasses}
				       columns={{xs: videosCount === 0 ? 1 : 2, sm: videosCount === 0 ? 1 : 3, md: videosCount === 0 ? 1 : 4, lg: videosCount === 0 ? 1 : 5}}
				       tileConfigs={tileConfigs}
				       defaultTileConfig={{footer: {show: {actorName: true}}, badges: {textBadges: {show: {price: isGuestLoggedIn}}}}}
				       tileSizes={tileSizes}
				/>
			</div>
		);
	}
}

SearchResultsVideosGrid.propTypes = {
	videos: PropTypes.array.isRequired,
};

export default SearchResultsVideosGrid;